const Home = () => import("@/views/Home"); // 首页

//订单 order
const OrderList = () => import("@/views/Order/list"); //订单列表

//协议 agreement
const Agreement = () => import("@/views/agreement/agreement"); //服务协议
const Privacy = () => import("@/views/agreement/privacy"); //隐私协议
const Purchase = () => import("@/views/agreement/purchase"); // 购买协议
const AppRoot = () => import("@/views/agreement/appRoot"); // 应用权限说明
const LiveAgreement = () => import("@/views/agreement/live"); // 直播协议
const YjAgreement = () => import("@/views/agreement/yjAgreement"); // 元晶用户协议

const Authentication = () => import("@/views/authentication/authentication"); // 实名认证

const AgreementFive = () => import("@/views/agreement/agreementH5"); //服务协议 h5
const PrivacyFive = () => import("@/views/agreement/privacyH5"); //隐私协议 h5
const PurchaseFive = () => import("@/views/agreement/purchaseH5"); // 购买协议 h5

//活动 activity
const OneTwo = () =>
  import("@/views/activity/invitation/vip/step_one/step_one"); //vip邀请第一步
const InvitationLogin = () =>
  import("@/views/activity/invitation/invitation_login/invitation_login"); // vip活动登录
const ChooseDestroy = () =>
  import("@/views/activity/invitation/choose_destroy/choose_destroy"); // 选择核销方式
const DestroyPhone = () =>
  import("@/views/activity/invitation/destroy_phone/destroy_phone"); // 手机号核销页

const OrderDetail = () => import("@/views/order_detail/order_detail"); // 订单详情

const qiugouNotify = () => import("@/views/qiugouNotify/qiugouNotify"); //求购列表

const Buy = () => import("@/views/buy/buyCopy"); //购买求购

const hexiao = () => import("@/views/hexiao/hexiao"); //核销列表

const hexiaoSucc = () => import("@/views/hexiao/hexiaoSucc"); //核销成功

const preview = () => import("@/views/preview/preview"); //预约

const quanyi = () => import("@/views/quanyi/quanyi"); //权益

const exchange = () => import("@/views/exchange/exchange"); //兑换

const exchangeSuccess = () =>
  import("@/views/exchange_success/exchange_success"); //兑换成功

//address 地址
const addressBook = () => import("@/views/address/address_book/address_book"); //地址簿
const addressDetail = () =>
  import("@/views/address/address_detail/address_detail"); //地址详情
const CraftingTable = () => import("@/views/craftingTable/craftingTable"); // 合成台

const NotFound = (resolve) => require(["@/views/error/404/404"], resolve); // 404

const routes = [
  {
    path: "/",
    redirect: {
      name: "home",
    },
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
  },
  {
    path: "/order/list",
    component: OrderList,
    name: "order_list",
    meta: {
      title: "订单列表",
    },
  },
  {
    path: "/home",
    name: "home",
    component: Home,
  },
  {
    path: "/order/detail",
    name: "orderDetail",
    component: OrderDetail,
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/agreement/agreement",
    name: "agreement",
    component: Agreement,
    meta: {
      title: "用户协议",
    },
  },
  {
    path: "/agreement/privacy",
    name: "privacy",
    component: Privacy,
    meta: {
      title: "隐私协议",
    },
  },
  {
    path: "/agreement/agreementfive",
    name: "agreementfive",
    component: AgreementFive,
    meta: {
      title: "用户协议",
    },
  },
  {
    path: "/agreement/privacyfive",
    name: "privacyfive",
    component: PrivacyFive,
    meta: {
      title: "隐私协议",
    },
  },
  {
    path: "/agreement/live",
    name: "liveAgreement",
    component: LiveAgreement,
    meta: {
      title: "直播协议",
    },
  },
  {
    path: "/agreement/yj_agreement",
    name: "yjAgreement",
    component: YjAgreement,
    meta: {
      title: "元晶用户协议",
    },
  },
  {
    path: "/authentication",
    name: "authentication",
    component: Authentication,
    meta: {
      title: "实名认证",
    },
  },
  {
    path: "/activity/vip/invitation/step_one",
    name: "step_one",
    component: OneTwo,
    meta: {
      title: "大有邀请函",
    },
  },
  {
    path: "/agreement/purchase",
    name: "purchase",
    component: Purchase,
    meta: {
      title: "购买协议",
    },
  },
  {
    path: "/agreement/appRoot",
    name: "appRoot",
    component: AppRoot,
    meta: {
      title: "应用权限说明",
    },
  },
  {
    path: "/agreement/purchasefive",
    name: "purchasefive",
    component: PurchaseFive,
    meta: {
      title: "购买协议",
    },
  },
  {
    path: "/qiugouNotify",
    name: "qiugouNotify",
    component: qiugouNotify,
    meta: {
      title: "求购通知列表",
    },
  },
  {
    path: "/activity/vip/buy",
    name: "buy",
    component: Buy,
    meta: {
      title: "购买",
    },
  },
  {
    path: "/activity/vip/hexiao",
    name: "hexiao",
    component: hexiao,
    meta: {
      title: "核销权益",
    },
  },
  {
    path: "/activity/vip/hexiaoSucc",
    name: "hexiaoSucc",
    component: hexiaoSucc,
    meta: {
      title: "核销成功",
    },
  },

  // vip活动登录
  {
    path: "/activity/vip/invitation/invitation_login",
    name: "invitation_login",
    component: InvitationLogin,
    meta: {
      title: "登录",
    },
  },
  // 选择核销方式
  {
    path: "/activity/vip/invitation/choose_destroy",
    name: "choose_destroy",
    component: ChooseDestroy,
    meta: {
      title: "选择核销方式",
    },
  },
  // 手机号核销页
  {
    path: "/activity/vip/invitation/destroy_phone",
    name: "destroy_phone",
    component: DestroyPhone,
    meta: {
      title: "输入手机号",
    },
  },
  //预约页面
  {
    path: "/activity/vip/invitation/preview",
    name: "preview",
    component: preview,
    meta: {
      title: "预约",
    },
  },
  //权益页面
  {
    path: "/activity/vip/quanyi",
    name: "quanyi",
    component: quanyi,
    meta: {
      title: "权益",
    },
  },
  //兑换
  {
    path: "/activity/vip/exchange",
    name: "exchange",
    component: exchange,
    meta: {
      title: "兑换",
    },
  },
  //兑换成功
  {
    path: "/activity/vip/exchangeSuccess",
    name: "exchangeSuccess",
    component: exchangeSuccess,
    meta: {
      title: "兑换成功",
    },
  },
  //地址簿
  {
    path: "/activity/vip/addressBook",
    name: "addressBook",
    component: addressBook,
    meta: {
      title: "地址簿",
    },
  },
  //地址详情
  {
    path: "/activity/vip/addressDetail",
    name: "addressDetail",
    component: addressDetail,
    meta: {
      title: "地址详情",
    },
  },
  {
    path: "/craftingTable",
    name: "craftingTable",
    component: CraftingTable,
    meta: {
      title: "合成台",
    },
  },
];

export default routes;
